import theme from "../theme";

const getJobTypeColor = (id: number) => {
  switch (id) {
    case 1: // Service Ticket
      return theme.palette.error.main;
    case 2: // Project
      return theme.palette.primary.main
    case 3: // Small Job
      return theme.palette.info.main;
    case 4: // PM
      return theme.palette.tertiary.main;
    case 5: // Sandbox
      return theme.palette.warning.main;
    case 6: // Training
      return theme.palette.success.light;
    case 7: // Meeting
      return theme.palette.text.primary;
    case 8: // Documentation
      return theme.palette.secondary.main;
    default:
      return theme.palette.primary.main;
  }
};

export default getJobTypeColor;
